import { render } from "./jobCategory.vue?vue&type=template&id=78e8d490&scoped=true"
import script from "./jobCategory.vue?vue&type=script&lang=js"
export * from "./jobCategory.vue?vue&type=script&lang=js"

import "./jobCategory.vue?vue&type=style&index=0&id=78e8d490&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e8d490"]])

export default __exports__